export default __webpack_public_path__ + "static/header-mobile-082e2caf9880ea14028228d179623f78.svg";